var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, IconButton, Menu, MenuItem, Stack, Tooltip } from "@mui/material";
import Typography from "@mui/material/Typography";
import * as React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useReadOnly } from "../utils/hooks/users/useReadOnly";
var Property = function (props) {
    var _a, _b, _c, _d, _e;
    var _f = React.useState(null), anchorEl = _f[0], setAnchorEl = _f[1];
    var open = Boolean(anchorEl);
    // A read-only user must not be able to interact with the control(s) inside a Property
    // (focus a text field, open an autocomplete/select, toggle a switch, ...). `inert` removes
    // the whole content subtree from the tab order and ignores pointer & focus events, which
    // covers every control type (including MUI's div-based Select and Autocomplete popups).
    var readOnly = useReadOnly();
    var contentRef = React.useRef(null);
    React.useEffect(function () {
        if (contentRef.current) {
            contentRef.current.inert = readOnly;
        }
    }, [readOnly]);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var mobileInline = props.mobileLayout === 'inline';
    var topAlignedLabel = props.labelAlignment === 'top';
    var title = (_jsxs(Typography, __assign({ variant: 'subtitle1', textAlign: 'start', sx: (_a = props.sx) === null || _a === void 0 ? void 0 : _a.title }, { children: [props.title, !!props.tooltip && (_jsx(Tooltip, __assign({ title: props.tooltip }, { children: _jsx(Box, __assign({ component: 'span', tabIndex: 0, "aria-label": typeof props.title === 'string' ? "".concat(props.title, " help") : 'More information', sx: {
                        color: 'text.secondary',
                        cursor: 'help',
                        display: 'inline-flex',
                        lineHeight: 0,
                        ml: 0.5,
                        verticalAlign: 'text-bottom',
                    } }, { children: _jsx(InfoOutlinedIcon, { sx: { fontSize: 13 } }) })) })))] })));
    return (_jsxs(Stack, __assign({ direction: props.orientation === 'vertical' ? 'column' : { xs: mobileInline ? 'row' : 'column', sm: 'row' }, gap: 1, width: "100%", alignItems: props.orientation === 'vertical' ? undefined : { xs: mobileInline ? 'center' : 'flex-start', sm: topAlignedLabel ? 'flex-start' : 'center' } }, { children: [_jsxs(Stack, __assign({ direction: props.orientation === 'vertical' ? 'row' : undefined, gap: 1, sx: 
                // The 200px column sizing only applies to the horizontal layout;
                // in a column container flex-basis would reserve 200px of HEIGHT.
                props.orientation === 'vertical'
                    ? undefined
                    : {
                        minWidth: { xs: mobileInline ? 0 : 'unset', sm: 200 },
                        width: { xs: mobileInline ? 'auto' : '100%', sm: 200 },
                        flex: { xs: mobileInline ? 1 : undefined, sm: '0 0 200px' },
                        mt: topAlignedLabel ? '2px' : undefined,
                    }, alignItems: props.orientation === 'vertical' ? 'center' : undefined }, { children: [title, !!props.subtitle &&
                        _jsx(Typography, __assign({ variant: 'caption', textAlign: 'start', sx: (_c = (_b = props.sx) === null || _b === void 0 ? void 0 : _b.subtitle) !== null && _c !== void 0 ? _c : (_d = props.sx) === null || _d === void 0 ? void 0 : _d.title }, { children: props.subtitle }))] })), _jsxs(Stack, __assign({ ref: contentRef, width: mobileInline ? { xs: 'auto', sm: '100%' } : '100%', direction: 'row', gap: 1, alignItems: 'center', justifyContent: mobileInline ? { xs: 'flex-end', sm: undefined } : undefined, sx: {
                    // Visual cue + belt-and-braces fallback for browsers without `inert` support.
                    pointerEvents: readOnly ? 'none' : undefined,
                    opacity: readOnly ? 0.6 : undefined,
                } }, { children: [props.children, !!((_e = props.additionalOptions) === null || _e === void 0 ? void 0 : _e.length) ? (_jsxs(_Fragment, { children: [_jsx(IconButton, __assign({ id: "more-menu-".concat(props.title), "aria-controls": open ? "basic-menu-".concat(props.title) : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: handleClick }, { children: _jsx(MoreVertIcon, {}) })), _jsx(Menu, __assign({ id: "basic-menu-".concat(props.title), anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                                    'aria-labelledby': 'basic-button',
                                } }, { children: props.additionalOptions.map(function (option, index) { return (_jsx(MenuItem, __assign({ onClick: function () {
                                        option.onClick();
                                        handleClose();
                                    } }, { children: option.title }), index)); }) }))] })) : null] })), props.actions] })));
};
export default Property;
